import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_CLICK_TO_VIEW_COMMENTS, STR_WRITE_YOUR_COMMENT } from "../Strings";
import LoginView from '../views/LoginView';


export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [isLiked, setIsLiked] = useState(false);
	const [numberOfLikes, setNumberOfLikes] = useState(0);


	function likesBuffer() {
		if(data) {
			return ((data.title.length) * 17);
		}

		return 121;
	}

	function comment() {
		appContext.navTo({
			item: 'bottom-view',
			subItem: 'article-commentor',
			extraItem: data.id,
		})
	}

	async function like(e) {

		e.stopPropagation();

		if (!isLiked) {
			setIsLiked(true);
			setNumberOfLikes(_prev => Number(_prev) + 1)
			await callApi('like-article', { id: data.id }).then(response => {
				if(response.status === 1) {
					//good action
				}
			})
		}
	}


	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function getData() {
		await callApi("get-article-data", { id }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			}
		})
	}

	useEffect(() => {
		if(data) {
			const likes = JSON.parse(data.likes);
			setNumberOfLikes(likes.length + likesBuffer());

			for (const like of likes) {
				if(Number(like) === Number(appContext.currentUserData.id)) {
					setIsLiked(true);
					break;
				}
			}
		}
	}, [data])

	useEffect(() => {
		init();
	}, [])



	if(appContext.auth && appContext.currentUserData) {
		if (ready && data) {
			return (
				<div className="container">
					<div className="row">
	
						<div className="col-md-12">
							<h6
								className="mSectionTitle"
								style={{
									
								}}
							>
								{data.title}
							</h6>
						</div>
	
						<div className="col-md-12">
							<img
								style={{
									width: "100%",
									height: "auto",
								}}
								src={CDN_URL+data.cover}
							/>
						</div>
	
						
						{
							!(appContext.currentUserData.subscriptionStatus === 'active') ?
								<>
									<div
										className="mt-4 mb-4 col-md-12"
									>
										<div
											className=""
											style={{
												width: "100%",
												padding: "0",
												overflow: "hidden",
											}}
											dangerouslySetInnerHTML={{ __html: data.content }}
										>
	
										</div>
									</div>
	
									
	
									<div className="col-md-12" style={{ padding: "20px" }}>
										{
											JSON.parse(data.linkedItems).map((item, i) => {
												return (
													<button
														key={i}
														className="btn btn-block btn-padded btn-outline-primary mt-2 mb-2"
														onClick={() => {
															appContext.navTo({
																item: item.navItem,
																subItem: item.navSubItem,
																extraItem: item.navExtraItem,
																moreItem: item.navMoreItem,
															})
														}}
													>
														{(appContext.language === 'en') ? item.titleEn : ""}
														{(appContext.language === 'sw') ? item.titleSw : ""}
													</button>
												)
											})
										}
									</div>
	
								</>
								:
								<div
									className="mt-4 mb-4 col-md-12"
								>
									<SubscriptionExpiredWidget />
								</div>
	
						}
	
					</div>
				</div>
			)
		} else {
			return (
				<div
					className="mSupportLoading container"
				>
					{getInlineLoader()}
				</div>
			);
		}
	} else {
		return (
			<LoginView/>
		)
	}


}